export default __webpack_public_path__ + "static/media/691.996794e0.gif";